import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, GeneralConfigType, KeyValues3, KeyValues5, KeyValueSet, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-whitelist-config',
  templateUrl: './whitelist-config.component.html',
  styleUrls: ['./whitelist-config.component.scss']
})
export class WhitelistConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["whitelist", "status"]; data: KeyValues3 = { key: '', v1: '', v2: '', v3: '' } as KeyValues3; selectedContact: KeyValues5;
  message: string = ''; isRedAlert: boolean = true; statuses: KeyValueSet[]; id = ''; ctryCode = ''; item: KeyValues5; isPopup = true; phoneNumber = '';
  maxBodyHeight = 0;
  elementIds: any = {
    ph_num: 'ph_num',
    name: 'nme',
    comment: 'cmt',
    save: 'save'
  };
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private profileManagementService: ProfileManagementService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id != '') {
      if (!this.statuses) {
        this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.WhiteListStatus).subscribe(result => {
          this.statuses = result;
        });
      }
      if (this.localService.getLoginAsCountryCode()  != '') {
        this.profileManagementService.getWhitelist(this.id, this.ctryCode).subscribe(result => {
          this.item = result;
          this.item.v1 = '+' + this.localService.countryCodes.find(x => x.v2 == this.ctryCode).v3 + ' ' + this.item.v1;
          this.data.v3 = this.item.v5;
        });
      }
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.message = '';
    if (this.id == '') {
      this.profileManagementService.addWhiteList(this.data, this.selectedContact.v2).subscribe(result => {
        switch (result) {
          case Status.Success: {
            if (this.isPopup) {
              this.activeModal.close({ event: TriggeredEvent.Ok, data: this.selectedContact });
            } else {
              this.message = this.localService.languageContent.status.success;
            }
          } break;
          case Status.Duplicate: {
            this.message = this.localService.languageContent.whitelist.duplicate;
          } break;
          case Status.InActive: {
            this.message = this.localService.languageContent.whitelist.deactivated;
          } break;
          case Status.NotAllowed: {
            this.message = this.localService.languageContent.whitelist.rejected;
          } break;
          case Status.New: {
            this.message = this.localService.languageContent.whitelist.requested;
          } break;
          case Status.DataRequired: {
            this.message = this.localService.languageContent.whitelist.data_needed;
            if (this.selectedContact.isReadonly)
              this.localService.onFocusNextInput(this.elementIds.name, FocusInputType.TextBox);
            else
              this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
          } break;
        }
      });
    } else if (this.localService.getLoginAsCountryCode()  != '') {
      this.profileManagementService.updateStatus(this.item.key, parseInt(this.item.v4), this.ctryCode, this.data.v3).subscribe(result => {
        switch (result) {
          case Status.Success: {
            if (this.isPopup) {
              this.activeModal.close({ event: TriggeredEvent.Ok, data: this.item.v4 });
            } else {
              this.message = this.localService.languageContent.status.success;
            }
          } break;
        }
      });
    }
  }

  onContactUpdated(e) {
    this.selectedContact = e;
    this.data.v1 = this.selectedContact.v5;
    if (this.selectedContact.isReadonly) {
      this.localService.onFocusNextInput(this.elementIds.name, FocusInputType.TextBox);
    }
  }

  onMessageClear() {
    this.message = '';
  }
}
